import { DEFAULT_TITLE } from '../const'

export const concursos = [
  {
    name: 'concursos',
    path: '/concursos',
    component: () => import('@/views/public/concursos'),
    meta: {
      title: `${DEFAULT_TITLE} | Concursos Públicos`
    }
  },
  {
    name: 'edital',
    path: '/concursos/edital/:edital',
    component: () => import('@/views/public/concursos/Edital'),
    meta: {
      title: `${DEFAULT_TITLE} | Detalhes do edital`
    }
  },
  {
    name: 'cargo',
    path: '/concursos/edital/:edital/cargo/:cargo',
    component: () => import('@/views/public/concursos/Cargo'),
    meta: {
      title: `${DEFAULT_TITLE} | Detalhes do cargo`
    }
  },
  {
    name: 'pesquisa_nome',
    path: '/concursos/pesquisa/nome/:nome',
    component: () => import('@/views/public/concursos/PesquisaNome'),
    meta: {
      title: `${DEFAULT_TITLE} | Pesquisa por candidato`
    }
  },
  {
    name: 'pesquisa_cargo',
    path: '/concursos/pesquisa/cargo/:cargo/:total',
    component: () => import('@/views/public/concursos/PesquisaCargo'),
    meta: {
      title: `${DEFAULT_TITLE} | Pesquisa por cargo`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/concursos.js